export default __webpack_public_path__ + "static/pipeline-dashboard-slider-5c8c44129a34a1bbd24f01c8f2429be8.mp4";